var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBookmarksConteudo01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_14_",
    d: "M31.9,33.7H4.1c-1.9,0-3.5-1.6-3.5-3.5V5.8c0-1.9,1.6-3.5,3.5-3.5h27.9c1.9,0,3.5,1.6,3.5,3.5v24.4 C35.4,32.1,33.9,33.7,31.9,33.7z M19.7,5.8v24.4h12.2V5.8H19.7z M4.1,5.8v24.4h12.2V5.8H4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2_5_",
    d: "M28.5,19.7h-5.2v-3.5h5.2V19.7z M28.5,12.8h-5.2V9.3h5.2V12.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBookmarksConteudo01);
export default __webpack_public_path__ + "static/media/ico-bookmarks-conteudo-01.6567241c88e47524a83215dc03cd087e.svg";
export { ForwardRef as ReactComponent };